import React, { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import ClientRequest from "../services/ClientRequest";

function CancellationForm() {
  const [accountCode, setAccountCode] = useState('');
  const [lastName, setLastName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = {};

    if (!lastName.trim()) {
      newErrors.lastName = 'Account code is required.';
    }

    if (!accountCode.trim()) {
      newErrors.accountCode = 'Account code is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setSubmitting(true);

    const request = new ClientRequest();
    const payload = {
      account_code: accountCode,
      last_name: lastName,
    };

    request.create("cancel-all-subscriptions", payload)
        .then(res => {
          const { success, errors, message } = res;
          if (success) {
            setSubmissionStatus('success');
            setMessage(message);
            setAccountCode('');
            setLastName('');
          } else {
            setSubmissionStatus('error');
            setMessage(message || errors || 'An unknown error occurred. Please try again or contact support.');
          }

        })
        .catch(err => {
          setSubmissionStatus('error');
          setMessage(err.message || 'An error occurred while submitting your request.');
        })
        .finally(() => {
          setSubmitting(false);
        });
  };

  return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12}>
            <Form onSubmit={handleSubmit}>
              <div className="rjs-main" style={{ width: '100%' }}>
                <div className="rjs-fieldset">
                  <h3 className="lead fw-bold">Cancellation Request</h3>
                  <p>
                    Please enter your account code found on your puzzle address cover sheet,
                    plus your last name, and your account will be cancelled with immediate effect.
                  </p>

                  {/* Account Code */}
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="accountCode">
                        <Form.Label>Account Code:</Form.Label>
                        <Form.Control
                            type="text"
                            value={accountCode}
                            onChange={(e) => setAccountCode(e.target.value)}
                            isInvalid={!!errors.accountCode}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.accountCode}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Last Name */}
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="lastName">
                        <Form.Label>Last Name:</Form.Label>
                        <Form.Control
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            isInvalid={!!errors.lastName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.lastName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Submit Button */}
                  <div className="d-grid gap-2 mb-2">
                    <Button
                        variant="primary"
                        size="lg"
                        type="submit"
                        disabled={submitting}
                    >
                      {submitting ? 'Submitting...' : 'Submit Cancellation'}
                    </Button>
                  </div>

                  {submissionStatus === 'success' && <div className="alert alert-success">{message}</div>}
                  {submissionStatus === 'error' && <div className="alert alert-danger">{message}</div>}
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
  );
}

export default CancellationForm;
